import { Children, isValidElement } from "react";

/**
 * Numbered step list. Wrap each step in <Step title="..."> children </Step>.
 * The wrapper auto-numbers them.
 */
export default function Steps({ children }) {
  const steps = Children.toArray(children).filter(isValidElement);
  return (
    <ol className="space-y-5">
      {steps.map((step, i) => {
        const number = i + 1;
        return (
          <li key={i} className="flex gap-4">
            <span className="inline-flex items-center justify-center h-7 w-7 rounded-full bg-primary text-primary-foreground text-xs font-bold shrink-0">
              {number}
            </span>
            <div className="flex-1 min-w-0 space-y-2 pt-0.5">{step}</div>
          </li>
        );
      })}
    </ol>
  );
}

export function Step({ title, children }) {
  return (
    <>
      {title && (
        <p className="font-display text-base font-semibold text-foreground leading-snug">
          {title}
        </p>
      )}
      <div className="text-muted-foreground leading-relaxed text-[15px] space-y-3 [&_strong]:text-foreground">
        {children}
      </div>
    </>
  );
}
